export default "__VITE_ASSET__mwpapVTG__"